export default {
    methods: {
        getVertaling(item) {
            return this.$texts.getText(item)
        }
    }
}